import { useControlsPreference } from 'components/Table/hooks';
import { ColumnControls as Control } from 'components/Table/controls/ColumnControls';

import { VisibilityControl } from 'components/Table/controls/VisibilityControl';
import { OrderControl } from 'components/Table/controls/OrderControl';
import { ColumnsList } from 'components/Table/TableControls';
import { PREFERENCE_KEYS } from 'types';
import { UpdateConfig } from 'components/Table';
import { memo, MutableRefObject, useCallback } from 'react';
import { useSavedFilterContext } from './contexts/savedFiltersContext';
import { useLatest } from '@qfa/react-components';
import { useFiltersContext } from './contexts/filtersContext';
import { isEqual } from 'lodash';

export const ColumnControls = memo(
  ({
    preferenceKey,
    columnsRef,
  }: {
    preferenceKey: PREFERENCE_KEYS;
    columnsRef?: MutableRefObject<UpdateConfig[]>;
  }) => {
    const [controlsPreference, _onChange] = useControlsPreference(preferenceKey);
    const {
      savedFilters: { setActiveSavedFilter, activeFilterData },
    } = useSavedFilterContext();
    const { filtersInitialized } = useFiltersContext();

    const activeFilterRef = useLatest(activeFilterData);

    const onChange = useCallback(
      (newColumns: UpdateConfig[]) => {
        _onChange(newColumns);
        // skip on initial mount
        if (filtersInitialized && activeFilterRef.current?.columns?.length) {
          setActiveSavedFilter(undefined);
        }
      },
      // exclude setActiveSavedFilter
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [_onChange, activeFilterRef, filtersInitialized]
    );

    return (
      <Control columnsRef={columnsRef} open component={ColumnsList} onChange={onChange}>
        <VisibilityControl state={controlsPreference} />
        <OrderControl />
      </Control>
    );
  },
  isEqual
);
